import { useState, useEffect, useContext } from "react";

import { AuthButton, AuthCard, AuthField, AuthNotice } from "./AuthCard";

import { getSessionToken, getTokenInfo, logOutUser, loginUser } from "../api/auth";
import { AppContext } from "@/AppContext";
import { getCampaigns } from "@/api/campaigns";
import { Link, useParams } from "react-router-dom";
import { startCase } from "lodash";
import { landingFor, nextFromLocation, postLoginDestination } from "./returnTo";

export const Login = ({ email: defaultEmail, password: defaultPassword }: { email: string, password: string }) => {
  const [email, setEmail] = useState(defaultEmail);
  const [password, setPassword] = useState(defaultPassword);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { setSidebarOpen, setRightSidebarOpen } = useContext(AppContext);

  const { name } = useParams();

  const handleSubmit = async () => {
    // event.preventDefault();
    setIsLoading(true);
    // alert("test")
    const data = await loginUser({ email, password });
    if (data) {
      if (data.error) {
        setErrorMessage(data.error);
      } else {
        console.log("the data", data);
        if (data?.token) {
          setSidebarOpen(true);
          // localStorage.setItem("token", data.token);

          // are there any profiles? if not, redirect to onboarding
          // const token = getSessionToken();
          // const response = await getCampaigns({ token, type: "planning" });

          // if (
          //   response &&
          //   response.filter(({ deleted }) => !deleted).length === 0
          // ) {
          //   const userInfo = await getTokenInfo(data.token);
          //   const { permissions } = userInfo;
          //   if (permissions?.includes("f$-internal")) window.location.href = "/order-forms"
          //   else window.location.href = "/copilot"; // go to the copilot home screen after log in
          // } else {
          //   // otherwise, redirect to the dashboard
          //   // window.location.href = "/";
          // }

          // LNK-1: back to the page they were trying to open, if they were sent here from one
          window.location.href = postLoginDestination(nextFromLocation(), landingFor(data.permissions));
          // console.log("response", response)
        } else {
          setErrorMessage("Unable to login. Please try again.");
        }
      }
    }

    setIsLoading(false);
  };

  useEffect(() => {

    // no sidebars
    setSidebarOpen(true);
    setRightSidebarOpen(false);

    // Opening this screen used to sign you out, which signed out every other tab too (they share
    // one sign-in). Now: sign out only when asked (/login?signout=1) or when the sign-in has expired;
    // if you're still signed in, go on into the app.
    const token = localStorage.getItem("token");
    if (!token) return;
    if (new URLSearchParams(window.location.search).get("signout")) {
      logOutUser({ token });
      return;
    }
    let live = true;
    getTokenInfo(token).then((info: any) => {
      if (!live) return;
      if (info && info.id && !info.error) window.location.href = postLoginDestination(nextFromLocation(), landingFor(info.permissions));
      else logOutUser({ token });
    });
    return () => {
      live = false;
    };
  }, []);

  const onSubmit = (e: React.FormEvent) => { e.preventDefault(); handleSubmit(); };

  return (
    <AuthCard
      title={name ? `Welcome, ${startCase(name)}!` : "Sign in to Launch OS"}
      subtitle={name ? "We've prepared a special demo for you. Sign in to continue." : "Welcome back. Enter your details to continue."}
    >
      <form onSubmit={onSubmit} noValidate>
        <AuthField label="Email" type="email" placeholder="Email" autoComplete="username" value={email} onChange={setEmail} />
        <AuthField
          label="Password"
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={setPassword}
          aside={<Link to="/forgot-password">Forgot password?</Link>}
        />
        {errorMessage && <AuthNotice tone="error">{errorMessage}</AuthNotice>}
        <AuthButton busy={isLoading} busyLabel="Signing in..." dataTestId="SignInButton">Sign In</AuthButton>
      </form>
    </AuthCard>
  );
};
